import { render, staticRenderFns } from "./BestKeywords.vue?vue&type=template&id=60611188&"
import script from "./BestKeywords.vue?vue&type=script&lang=js&"
export * from "./BestKeywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports